import {useEffect} from 'react'
import {PageEditModalHeader} from './PageEditModalHeader'
import {PageEditModalFormWrapper} from './PageEditModalFormWrapper'

const PageEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_page'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
        style={{zIndex: 1055}}
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-dialog-w50'>
        {/* begin::Modal content */}
          <div className='modal-content border-0 rounded-4 shadow-lg'>
            <PageEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y px-8 py-6'>
              <PageEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show' style={{backgroundColor: 'rgba(15, 23, 42, 0.45)', zIndex: 1050}}></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {PageEditModal}
